
import Transformer from './../transformer'

export default class HighwayTransformer extends Transformer {
  static fetch(highway) {
    return {
      id: highway.id || 0,
      name: highway.name || '',
      highwayCompany: highway.highway_company.highway_company_id,
      highwayCompanyName: highway.highway_company.highway_company_name,
      customer: highway.customer.highway_customer_id,
      customerName: highway.customer.highway_customer_name,
      highwayNumber: highway.highway_number,
      addDate: highway.add_date,
      description: highway.description,
    }
  }

  static send(highway) {
    return {
      id: highway.id,
      name: highway.name,
      highway_company: highway.highwayCompany,
      customer: highway.customer,
      highway_number: highway.highwayNumber,
      addDate: highway.add_date,
      description: highway.description,
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/highway.js